/* AKHZ 2026-10-12 (Kalle: "kan artist statement expandera/kollapsa efter första stycket").
   Shows the first paragraph of an artist statement and folds the rest behind a More / Less link.
   Kalle: the link sits inline at the end of the last visible paragraph ("efter bends perception"); a signature line (starting with a dash) stays below.
   Targets: the home statement section (template section id ending in __statement) and any [data-akhz-collapse] block. */
(function () {
  function setup(box) {
    if (!box || box.dataset.akhzCollapseReady) return;
    var paras = Array.prototype.filter.call(box.children, function (el) { return el.tagName === 'P' && el.textContent.trim() !== ''; });
    var sign = paras.filter(function (el) { return /^[—–-]\s/.test(el.textContent.trim()); });
    sign.forEach(function (el) { el.classList.add('akhz-collapse__sign'); });
    paras = paras.filter(function (el) { return sign.indexOf(el) < 0; });
    if (paras.length < 2) return;
    box.dataset.akhzCollapseReady = '1';
    /* Everything after the first paragraph folds away (paragraphs, headings, lists, buttons), except the signature. */
    var rest = Array.prototype.filter.call(box.children, function (el) { return el !== paras[0] && sign.indexOf(el) < 0 && (paras[0].compareDocumentPosition(el) & 4); });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'akhz-collapse__toggle';
    btn.setAttribute('aria-expanded', 'false');
    function show(open) {
      rest.forEach(function (el) { el.hidden = !open; });
      btn.textContent = open ? (box.getAttribute('data-akhz-less') || 'Less') : (box.getAttribute('data-akhz-more') || 'More');
      var host = open ? paras[paras.length - 1] : paras[0];
      /* the last word before the link and the link sit in one unbreakable span, so "More" never sits alone on a line */
      var keep = btn.parentElement && btn.parentElement.classList.contains('akhz-collapse__keep') ? btn.parentElement : null;
      if (keep) { while (keep.firstChild && keep.firstChild !== btn) keep.parentNode.insertBefore(keep.firstChild, keep); keep.parentNode.insertBefore(btn, keep); keep.remove(); }
      var tn = null, tw = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null), x;
      while ((x = tw.nextNode())) { if (x.nodeValue.trim() && !x.parentElement.closest('.akhz-collapse__toggle')) tn = x; }
      keep = document.createElement('span'); keep.className = 'akhz-collapse__keep'; keep.style.whiteSpace = 'nowrap';
      if (tn) {
        var v = tn.nodeValue.replace(/\s+$/, ''), k = v.search(/\S+$/);
        tn.nodeValue = v.slice(0, k);
        keep.appendChild(document.createTextNode(v.slice(k) + ' '));
        tn.parentNode.insertBefore(keep, tn.nextSibling);
      } else { host.appendChild(keep); }
      keep.appendChild(btn);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (window.prlxAnimation) window.prlxAnimation();
    }
    btn.addEventListener('click', function () { show(btn.getAttribute('aria-expanded') !== 'true'); });
    show(false);
  }
  function init() {
    document.querySelectorAll('[id$="__statement"] .rich-text__content, [id$="__statement"] .image-with-text__description, [id$="__atelier"] .rte, [data-akhz-collapse]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
